import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import PublicLayout from 'v2/components/Shared/PublicLayout';

const AccountCreated = () => {
  return (
    <PublicLayout>
      <Grid container>
        <Grid item xs={12}>
          <Card>
            <CardContent style={{ textAlign: 'center', padding: 30 }}>
              <Typography variant='subtitle1'>Conta bancária enviada para aprovação!</Typography>
              <Typography variant='subtitle2'>
                Sua conta bancária será moderada pelo nosso setor financeiro. Esse processo costuma ser rápido (de 1 a 5 dias úteis). Fique tranquilo,
                vamos nos esforçar para ser no menor tempo possível.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </PublicLayout>
  );
};

export default AccountCreated;
